// extracted by mini-css-extract-plugin
export default {"header":"App_header__G2poH","link":"App_link__dHhPH","button":"App_button__xVIJI","subLink":"App_subLink__E9swZ","dropdownFooter":"App_dropdownFooter__EhBSa"};